import ConfirmationDialog from "@/components/common/ConfirmationDialog";
import { DialogOverlay } from "@/components/ui/dialog";
import useScheduledBriefingStore from "@/store/news-alerts/scheduled-briefing/scheduled-briefing.slice";

const DeleteScheduledBriefingModal = () => {
  const isOpen = useScheduledBriefingStore(
    (state) => state.isDeleteScheduledBriefingModalOpen,
  );
  const isDeleting = useScheduledBriefingStore(
    (state) => state.isDeletingScheduledBriefing,
  );
  const briefingName = useScheduledBriefingStore(
    (state) => state.deletingScheduledBriefingName,
  );
  const closeModal = useScheduledBriefingStore(
    (state) => state.closeDeleteScheduledBriefingModal,
  );
  const deleteScheduledBriefing = useScheduledBriefingStore(
    (state) => state.deleteScheduledBriefing,
  );

  return (
    <DialogOverlay isOpen={isOpen}>
      <ConfirmationDialog
        title="Are you sure you want to delete this briefing?"
        onCancelClick={closeModal}
        submitLoading={isDeleting}
        submitText="Yes, delete"
        submittingText="Deleting"
        submitVariant="secondaryDestructive"
        onSubmitClick={deleteScheduledBriefing}
      >
        <p className="text-sm leading-tight font-normal">
          {`This will permanently delete the "${briefingName}" scheduled briefing.`}
        </p>
      </ConfirmationDialog>
    </DialogOverlay>
  );
};

export default DeleteScheduledBriefingModal;
